import React from 'react';
import { connect } from 'react-redux';

import { Container, Header, Message, Rail } from 'semantic-ui-react';


const NewsPanel = ({ news }) => (
  news.messages && news.messages.length > 0 ? 
    <Rail attached internal close position='right'>
      <Container style={{ marginTop: 150, marginRight: 10, textAlign: 'left' }}>
        <Header as='h3'>{'Uutiset'}</Header>
        {news.messages.map((msg, i) => (
          <Message key={i} header={msg.header} list={msg.items} />
        ))}
      </Container>
    </Rail> : null
);

export default connect(state => ({ news: state.news }))(NewsPanel)



// WEBPACK FOOTER //
// ./src/containers/app/newsPanel.js